// Converted from application/views/sculptures/wind&sea-m_v.php. Edit this component directly.
export default function SculpturesWindSeaMPage() {
  return <><div class={"firstContainer container photoLeft"}>
<figure class={"photo"}>
<img src={"/assets/images/sculptures/wind&sea/wind&sea-m-castle.jpg"} alt={"Wind & Sea"} />
<figcaption>{"#1"}</figcaption>
</figure>
<div class={"text"}>
<div>
<div class={"mainTitleWrp"}>
<h1>{"Wind & Sea "}<small>{"(M)"}</small></h1>
<p>
<b>{"Dimensions: 1.15m high (3’ 8”)"}<br />{"\n                        Bronze"}<br />
</b></p><b>
</b></div><b>
</b></div><b>
</b></div><b>
</b></div><b>
<div class={"container photoRight"}>
<div class={"text"}>
<div>
<p>{"\n                Wind & Sea (M) sculpture (1.15m high) was made by Paddy Campbell in 2023 and is based on the original monumental sculpture (XL) of the same name (4.3m high) exhibited at his “Di Cuore” exhibition at the Palazzo Medici Riccardi in Florence.\n            "}</p>
</div>
</div>
<figure class={"photo"}>
<img src={"/assets/images/sculptures/wind&sea/wind&sea-m.jpg"} alt={"Wind & Sea"} />
<figcaption>{"#2"}</figcaption>
</figure>
</div>
<div class={"container photoLeft"}>
<figure class={"photo"}>
<img src={"/assets/images/sculptures/wind&sea/wind&sea-m-garden.jpg"} alt={"Wind & Sea"} />
<figcaption>{"#3"}</figcaption>
</figure>
<div class={"text"}>
<div>
<p>{"\n                Wind & Sea (M) sculpture was first exhibited at the Gormleys Art + Soul exhibition at the Culloden Hotel, Belfast, Ireland in 2023.\n            "}</p>
</div>
</div>
</div>
</b></>;
}
